import { Flex, Typography, Image, Checkbox, Popconfirm } from 'antd';
import { Machine } from '../../../../types';
import { Container, DeleteButton, StyledField } from './style';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import Icon from '@ant-design/icons';
import { SVGUnlink } from '../../../../images';
import { ImageContainer } from '../../../../styles/commonStyles';

export interface MachineCheckboxProps {
  checkable?: boolean;
  checked?: boolean;
  onCheckChange?: (checked: boolean) => void;
  machine: Machine;
  deletable?: boolean;
  onDelete?: (machine: Machine) => Promise<void>;
}

const Field = ({ label, value }: { label?: string; value?: string }) => (
  <StyledField gap={10}>
    <span className="label">{label}</span>
    <span>{value || '-'}</span>
  </StyledField>
);

const MachineCheckbox = ({
  checkable,
  checked,
  machine,
  onCheckChange,
  deletable,
  onDelete,
}: MachineCheckboxProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Container
      className={checked ? 'checked' : ''}
      align="center"
      gap={16}
      onClick={() => onCheckChange && onCheckChange(!checked)}
    >
      {checkable && (
        <Checkbox
          onChange={(e) => onCheckChange && onCheckChange(e.target.checked)}
          checked={checked}
        ></Checkbox>
      )}
      <Flex style={{ height: 60 }}>
        <ImageContainer style={{ width: 80, height: 60 }}>
          <Image
            src={machine?.images?.[0]?.url}
            preview={false}
            fallback="/placeholder.png"
          />
        </ImageContainer>
      </Flex>
      <Flex flex={1} vertical gap={8}>
        <Flex gap={20}>
          <Typography.Text style={{ color: theme.antd.colorPrimary }}>
            {machine.name}
          </Typography.Text>
          <Field label={t('alias')} value={machine.alias} />
        </Flex>
        <Flex gap={16}>
          <Field label={t('template')} value={machine.templateName} />
          <Field label={t('machine_type')} value={machine.type} />
          <Field label={t('manufacturer')} value={machine.manufacturer} />
        </Flex>
      </Flex>
      {deletable && (
        <Popconfirm
          placement="topRight"
          title={`Are you sure you want to remove ${machine.name}`}
          okText={t('yes')}
          cancelText={t('no')}
          onConfirm={(e) => (onDelete ? onDelete(machine) : null)}
        >
          <DeleteButton>
            <Icon component={SVGUnlink} />
          </DeleteButton>
        </Popconfirm>
      )}
    </Container>
  );
};

export default MachineCheckbox;
